<template>
  <div class="d-flex align-center">
    <v-avatar size="75px" color="grey">
      <img v-if="profilePic" :src="profilePic" :lazy-src="profilePic" />
    </v-avatar>
    <calendar v-if="userId" :userId="userId" class="profile-calendar"/>
  </div>
</template>

<script>
import Calendar from "@/components/dashboard/components/columns/Calendar";

export default {
  name: "ProfilePic",
  props: {
    profilePic: {
      type: String,
      required: true
    },
    userId: {
      type: [ Number, String ],
      required: false
    }
  },
  components: {
    Calendar
  }
}
</script>

<style lang="scss" scoped>
.profile-calendar {
  position: relative;
  bottom: -25px;
  left: -25px;
  width: 0;
}
</style>
